<!-- <div style="display: flex;     justify-content: center;">
    <p-progressSpinner [style]="{width: '50px', height: '50px' }" *ngIf="!drillDownDataStatus"></p-progressSpinner>
</div> -->


    <div *ngIf="drillDownDataStatus" class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right" class="parent_dialog" >
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu_dialog.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload" 
                    class="p-button-help"></button>
               
                <p-menu styleClass="prime-slider-override" class="child_dialog"  #menu_dialog [popup]="true" [model]="appVerificationItems_dialog"></p-menu>
            </ng-template>
    
        </p-toolbar>
        <p-table #miSurvey [value]="drillDownData" [scrollable]="true" scrollHeight="flex" scrollHeight="400px" dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true"
        [globalFilterFields]="[
        'AppId',
        'ActionId',
        'Level_Id', 
        'UserId',
        'Status_Ar',
        'Status',
        'Active_status',
        'Assigned_Date',
        'Action_Date',
        'componentId',
        'District',
        'Months',
        'Years',
        'Area',
        
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id" 
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
       (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">

            <tr>
              
                
                <th pSortableColumn="AppId">{{'APP_ID'| translate}}
                    <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                    <p-sortIcon field="AppId"></p-sortIcon>
                </th>
                <th pSortableColumn="ActionId">{{'ACTION'| translate}}
                    <p-columnFilter type="text" field="ActionId" display="menu"></p-columnFilter>
                    <p-sortIcon field="ActionId"></p-sortIcon>
                </th>
                <th pSortableColumn="Level_Id">{{'LEVEL_ID'| translate}}
                    <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                    <p-sortIcon field="Level_Id"></p-sortIcon>
                </th>
                <th pSortableColumn="UserId">{{'USER_NAME'| translate}}
                    <p-columnFilter type="text" field="UserId" display="menu"></p-columnFilter>
                    <p-sortIcon field="UserId"></p-sortIcon>
                </th>
                
                <th pSortableColumn="Status">{{'STATUS'| translate}}
                    <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
                    <p-sortIcon field="Status"></p-sortIcon>
                </th>
                
                <th pSortableColumn="Assigned_Date">{{'ASSIGNED_DATE'| translate}}
                    <p-columnFilter type="text" field="Assigned_Date_filter" display="menu"></p-columnFilter>
                    <p-sortIcon field="Assigned_Date"></p-sortIcon>
                </th>
                <th pSortableColumn="Action_Date">{{'ACTION_DATE'| translate}}
                    <p-columnFilter type="text" field="Action_Date_filter" display="menu"></p-columnFilter>
                    <p-sortIcon field="Action_Date"></p-sortIcon>
                </th>
                <th *ngIf="isComponentId" pSortableColumn="componentId">{{'COMPONENT'| translate}}
                    <p-columnFilter type="text" field="componentId" display="menu"></p-columnFilter>
                    <p-sortIcon field="componentId"></p-sortIcon>
                </th>
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Months">{{'MONTHS'| translate}}
                    <p-columnFilter type="text" field="Months" display="menu"></p-columnFilter>
                    <p-sortIcon field="Months"></p-sortIcon>
                </th>
                <th pSortableColumn="Years">{{'YEARS'| translate}}
                    <p-columnFilter type="text" field="Years" display="menu"></p-columnFilter>
                    <p-sortIcon field="Years"></p-sortIcon>
                </th>
                <th *ngIf="isArea" pSortableColumn="Area">{{'AREA'| translate}}
                    <p-columnFilter type="text" field="Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Area"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <p-progressSpinner *ngIf="!drillDownData"></p-progressSpinner>
        <ng-template pTemplate="body" let-drillDownData >
            <tr>
                <td>{{drillDownData.AppId}}</td>
                <td>{{drillDownData.ActionId}}</td>
                <td>{{drillDownData.Level_Id}}</td>
                <td>{{drillDownData.UserId}}</td>
                <td>{{drillDownData.Status}}</td>
                <td>{{drillDownData.Assigned_Date_filter}}</td>
                <td>{{drillDownData.Action_Date_filter}}</td>
                <td *ngIf="isComponentId">{{drillDownData.componentId}}</td>
                <td>{{drillDownData.District}}</td>
                <!-- <td  *ngIf="drillDownData.hasOwnProperty('Block');">{{drillDownData.Block}}</td> -->
                <td>{{drillDownData.Months}}</td>
                <td>{{drillDownData.Years}}</td>
                <td *ngIf="isArea">{{drillDownData.Area}}</td>
                
                
            </tr>
        </ng-template>
        <ng-template *ngIf="isArea && drilldownDetails.actionType=='VendorMIArea'" pTemplate="footer">
            <tr>
                <td ></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Total</td>
                <td>{{totalArea | number:'1.0-2'}}</td>
             </tr>
            <tr>
                <td ></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Grand Total</td>
                <td>{{grandTotalArea | number:'1.0-2'}}</td>
             </tr>
        </ng-template>
    
        </p-table>
    </div>

